function init() {

    /**
     * PGA Sustainability - Mobile Navigation
     * Features: Top-down expand, horizontal slide, focus trapping, and inert states.
     */

    const menuToggle = document.getElementById('menu-toggle');
    const navContainer = document.getElementById('nav-container');
    const logoLink = document.querySelector('.site-logo a');
    const mainContent = document.getElementById('mainContent');
    const skipNavLink = document.getElementById('skipNavLink');
    const footer = document.querySelector('footer');

    // State tracking for focus return when navigating back to Step 2
    let lastTrigger = null;

    // Initialize inert state on sub-panels
    document.querySelectorAll('.menu-panel:not(.active)').forEach(p => {
        p.setAttribute('inert', '');
    });

    /**
     * Toggle inert on page content outside the menu
     */
    function setPageInert(isInert) {
        [skipNavLink, mainContent, footer].forEach(el => {
            if (el) {
                isInert ? el.setAttribute('inert', '') : el.removeAttribute('inert');
            }
        });
    }

    /**
     * 1. The Dynamic Focus Trap
     * Loops focus within the menu when open
     */
    function handleFocusTrap(e) {
        if (e.key !== 'Tab' || menuToggle.getAttribute('aria-expanded') === 'false') return;

        const activePanel = navContainer.querySelector('.menu-panel.active');
        if (!activePanel) return;

        const panelElements = Array.from(activePanel.querySelectorAll('button, a, input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])'))
            .filter(el => !!(el.offsetWidth || el.offsetHeight));

        // The cycle: [Logo] + [Toggle/X] + [Active Panel Buttons/Links]
        const focusable = [logoLink, menuToggle, ...panelElements].filter(Boolean);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    document.addEventListener('keydown', handleFocusTrap);

    /**
     * 2. Transition Logic: Step 2 <-> Step 3
     * Handles horizontal sliding and focus hand-off
     */
    function transitionPanel(targetId, isForward) {

        const target = document.getElementById(targetId);
        const current = navContainer.querySelector('.menu-panel.active');

        if (!target || !current) return;

        // Capture focus target before any DOM changes
        const focusTarget = isForward
            ? target.querySelector('.back-button')
            : lastTrigger;

        // Activate target panel
        target.classList.add('active');
        target.removeAttribute('inert');
        target.setAttribute('aria-hidden', 'false');

        // Inert and deactivate current panel
        current.setAttribute('inert', '');
        current.classList.remove('active');
        current.setAttribute('aria-hidden', 'true');

        if (isForward) {
            current.classList.add('exit-left');
        } else {
            target.classList.remove('exit-left');
        }

        // Focus after panel transition completes
        var didFocus = false;
        function applyFocus() {
            if (didFocus) return;
            didFocus = true;
            if (focusTarget) focusTarget.focus();
        }

        target.addEventListener('transitionend', function onTransitionEnd(e) {
            if (e.propertyName === 'transform') {
                target.removeEventListener('transitionend', onTransitionEnd);
                applyFocus();
            }
        });

        // Fallback: if transitionend doesn't fire (e.g. inert suppressed the transition),
        // still restore focus after the expected transition duration.
        setTimeout(applyFocus, 400);

    }

    /**
     * 3. Primary Toggle: Step 1 -> Step 2
     * Handles vertical expansion and inert state for accessibility
     */
    menuToggle.addEventListener('click', () => {

        const isOpening = menuToggle.getAttribute('aria-expanded') === 'false';

        if (isOpening) {

            navContainer.hidden = false;
            navContainer.removeAttribute('inert');
            setPageInert(true);
            document.body.classList.add('menu-open');

            // Wait for repaint to ensure animation triggers
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    menuToggle.setAttribute('aria-expanded', 'true');
                    navContainer.classList.add('is-visible');

                    // Initial focus on first Step 2 button
                    const firstBtn = navContainer.querySelector('.drill-down');
                    if (firstBtn) firstBtn.focus();
                });
            });

        } else {

            menuToggle.setAttribute('aria-expanded', 'false');
            navContainer.classList.remove('is-visible');
            document.body.classList.remove('menu-open');
            navContainer.setAttribute('inert', '');

            setTimeout(() => {
                navContainer.hidden = true;
                resetToMainPanel();
                setPageInert(false);
                menuToggle.focus();
            }, 400);

        }
    });

    // Drill-down button listeners
    document.querySelectorAll('.drill-down').forEach(btn => {
        btn.addEventListener('click', () => {
            lastTrigger = btn;
            transitionPanel(btn.dataset.target, true);
        });
    });

    // Back button listeners
    document.querySelectorAll('.back-button').forEach(btn => {
        btn.addEventListener('click', () => {
            transitionPanel(btn.dataset.target, false);
        });
    });

    /**
     * 4. Global Helpers
     */
    function resetToMainPanel() {
        document.querySelectorAll('.menu-panel').forEach(p => {
            p.classList.remove('active', 'exit-left');
            p.setAttribute('aria-hidden', 'true');
            p.setAttribute('inert', '');
        });
        const main = document.getElementById('panel-main');
        main.classList.add('active');
        main.setAttribute('aria-hidden', 'false');
        main.removeAttribute('inert');
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
            menuToggle.click();
        }
    });
}

const api = {
    init: init
};

export default api;
